import React, { Component } from 'react';
import { Card, CardBody } from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';

class SupportView extends Component {

	constructor(props) {
		super(props);

		this.state = {
			content: this.props.SupportData,
		};
	}

	render() {
		return (
			<Card>
				<CardBody>
					{ReactHtmlParser(this.state.content)}
					TEST 2
				</CardBody>
			</Card>
		);
	}
}

export default SupportView;
